import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { singUp } from "../../../api/endpoints/AuthEndpoints";

export default function useSignUp() {
  return useMutation<
    void,
    AxiosError,
    {
      signUpData: {
        name: string;
        surname: string;
        email: string;
        password: string;
        languageIds: string[];
      };
    }
  >({
    mutationKey: ["sign-up"],
    mutationFn: ({ signUpData }) => singUp(signUpData),
  });
}
